module.exports = __webpack_public_path__ + "img/sniperrifle.0711765f.svg";